import type { CSSProperties, FunctionComponent } from 'react';

import { getFontSize } from '../../lib';

import styles from './CasinoChip.module.css';

type CasinoChipProps = {
  valueText: string;
  color?: CSSProperties['color'];
  computeStyles: CSSProperties;
};

export const CasinoChip: FunctionComponent<CasinoChipProps> = ({ valueText, color, computeStyles }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={styles.casinoChip} style={computeStyles} viewBox="0 0 1000 1000">
      <circle cx="500" cy="500" r="499" fill={color || 'var(--chipBackground)'} />
      <path fill="#000" fillOpacity=".2" d="M866 500a365 365 0 1 1-730 0 365 365 0 0 1 730 0Z" />
      <path
        fill="#fff"
        fillOpacity=".6"
        d="M865 624a385 385 0 0 1-729 0l19-6a365 365 0 0 0 691 0l19 6Zm0-248a385 385 0 0 0-729 0l19 6a365 365 0 0 1 691 0l19-6Z"
      />
      <path
        fill="#E1E1E1"
        d="M620 14a500 500 0 0 0-239 0l18 78a421 421 0 0 1 203 0l18-78Zm183 194c47 49 82 109 101 176l77-24a500 500 0 0 0-120-206l-58 54Zm178 432-77-24c-19 67-54 127-101 176l58 54a500 500 0 0 0 120-206ZM620 986l-18-78a421 421 0 0 1-203 0l-18 78a500 500 0 0 0 239 0ZM140 846l58-54c-47-49-82-109-101-176l-77 24a500 500 0 0 0 120 206ZM20 360l77 24c19-67 54-127 101-176l-58-54C84 212 43 283 20 360Z"
      />
      <foreignObject x="0" y="0" width="1000" height="1000">
        <div
          className={styles.casinoChip__value}
          style={{ '--chipFontSize': `${getFontSize(valueText)}px` } as CSSProperties}
        >
          {valueText}
        </div>
      </foreignObject>
    </svg>
  );
};
